import { Car, CreateNewCar } from "../../entities/car";
import { Formik, FormikHelpers, FormikProps, Form, Field } from "formik";
import { object, string, number } from "yup";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { FormTextField } from "../../shared/ui/form-input";
import { createCar } from "../../entities/car/api";
import CostumerAutocompleteSearchBar from "../../entities/costumer/ui/costumer-autocomplete-search-bar.component";
import { Costumer } from "../../entities/costumer";
import { useState } from "react";

let carSchema = object({
  brand: string().required("Marca é obrigatório"),
  model: string().required("Modelo é obrigatório"),
  plate: string().required("Placa é obrigatória"),
  chassisNumber: string().required("Chassi é obrigatório"),
  color: string().required("Cor é obrigatória"),
  insuranceName: string().required("Seguro é obrigatório"),
  mileage: number().nullable().integer("KM deve ser um número inteiro").min(0, "KM deve ser maior ou igual a 0").optional(),
}).required();


const CreateCar = () => {
  const [costumer, setCostumer] = useState<Costumer>({} as Costumer);

  return (
    <Container component="main" maxWidth="md">
      <Box
        sx={{
          minHeight: "72vh",
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography component="h1" variant="h4">
          Adicionar Carro
        </Typography>
        <Paper
          elevation={3}
          sx={{
            marginTop: 4,
            padding: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Formik
            initialValues={CreateNewCar()}
            validationSchema={carSchema}
            onSubmit={(
              values: Car,
              formikHelpers: FormikHelpers<Car>
            ) => {
              const formkiCreateCar = async () => {
                try {
                  if (!costumer.id) {
                    formikHelpers.setSubmitting(false);
                    return toast.error("Selecione um cliente antes de adicionar o carro.");
                  }
                  values.costumerId = costumer.id;
                  const res = await createCar(values);

                  if (res?.error) {
                    formikHelpers.setSubmitting(false);
                    return toast.error(res.error.message);
                  }

                  formikHelpers.setSubmitting(false);
                  toast.success("Carro adicionado com sucesso!");
                  formikHelpers.resetForm();
                  setCostumer({} as Costumer);

                } catch (err) {
                  toast.error("Erro ao adicionar carro");
                  formikHelpers.setSubmitting(false);
                }
              };
              formkiCreateCar();
            }}
          >
            {(formikProps: FormikProps<Car>) => (
              <Form noValidate autoComplete="off">
                <Grid item xs={12} sm={12}>
                  <CostumerAutocompleteSearchBar
                    value={costumer}
                    onChange={(c) => setCostumer(c || {} as Costumer)}
                  />
                </Grid>
                <Grid container spacing={2} mt={1}>
                  <Grid item xs={12} md={12}>
                    <Field
                      name="brand"
                      label="Marca"
                      size="small"
                      required
                      fullWidth
                      component={FormTextField}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Field
                      name="model"
                      label="Modelo"
                      size="small"
                      required
                      fullWidth
                      component={FormTextField}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Field
                      name="plate"
                      label="Placa"
                      size="small"
                      required
                      fullWidth
                      component={FormTextField}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Field
                      name="chassisNumber"
                      label="Chassi"
                      size="small"
                      required
                      fullWidth
                      component={FormTextField}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Field
                      name="color"
                      label="Color"
                      size="small"
                      required
                      fullWidth
                      component={FormTextField}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Field
                      name="insuranceName"
                      label="Seguro"
                      size="small"
                      required
                      fullWidth
                      component={FormTextField}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Field
                      name="mileage"
                      label="KM"
                      size="small"
                      type="number"
                      fullWidth
                      component={FormTextField}
                    />
                  </Grid>
                  <Grid item xs={12} mt={3}>
                    <LoadingButton
                      type="submit"
                      fullWidth
                      variant="contained"
                      loading={formikProps.isSubmitting}
                      disabled={formikProps.isSubmitting}
                    >
                      Adicionar Carro
                    </LoadingButton>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Paper>
      </Box>
      <ToastContainer />
    </Container>
  );
};

export default CreateCar;
